var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ServiceDataBase } from "./ServiceData";
import { MapProperty, MapGetMethod, MapSetMethod } from "@/utils/mapper/ClassMapper";
var ServiceInfo = (function (_super) {
    __extends(ServiceInfo, _super);
    function ServiceInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.language = 'en';
        _this.token = '';
        return _this;
    }
    ServiceInfo.prototype.setData = function (data) {
    };
    ServiceInfo.prototype.getData = function () {
    };
    __decorate([
        MapProperty({ from: 'Language' })
    ], ServiceInfo.prototype, "language", void 0);
    __decorate([
        MapProperty({ from: 'Token' })
    ], ServiceInfo.prototype, "token", void 0);
    __decorate([
        MapSetMethod()
    ], ServiceInfo.prototype, "setData", null);
    __decorate([
        MapGetMethod()
    ], ServiceInfo.prototype, "getData", null);
    return ServiceInfo;
}(ServiceDataBase));
export default ServiceInfo;



//////////////////
// WEBPACK FOOTER
// ./src/modules/services/models/ServiceInfo.ts
// module id = null
// module chunks = 